import { withAlpha } from "@/lib/color";
// AUTO-ESTRATTO da Mercato.jsx (refactor strutturale Fase 10.02) — nessun cambio di logica/UI/testid.
import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import PlayerAvatar from "@/components/PlayerAvatar";
import { FavoriteStar } from "@/components/FavoriteStar";
import { trPositionShort } from "@/lib/pesTranslations";
import { rosterStyleLabel } from "@/pages/team-detail/helpers";
import { MakeOfferModal } from "@/pages/TeamDetail";
import { POSITION_ORDER, fmt } from "./constants";

export function VetrinaPanel({ user }) {
    const [searchParams] = useSearchParams();
    const [listings, setListings] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showSell, setShowSell] = useState(false);
    const [typeFilter, setTypeFilter] = useState("all");
    const [roleFilter, setRoleFilter] = useState("");
    const [teamFilter, setTeamFilter] = useState(searchParams.get("team") || "");
    const [priceSort, setPriceSort] = useState("");
    const [offerCtx, setOfferCtx] = useState(null); // {target, sellerTeamId, sellerTeamName}
    const [offerLoadingId, setOfferLoadingId] = useState(null);
    const [myPendingOffers, setMyPendingOffers] = useState({}); // entry_id -> deal_id (mia offerta pending)

    const refresh = async () => {
        try {
            const [lst, deals] = await Promise.all([
                api.get("/market/listings"),
                user?.team_id
                    ? api.get("/market/deals", { params: { status: "pending", team_id: user.team_id } }).catch(() => ({ data: [] }))
                    : Promise.resolve({ data: [] }),
            ]);
            setListings(lst.data || []);
            const map = {};
            (deals.data || []).forEach((d) => {
                if (d.buyer_team_id === user?.team_id && d.player_id) map[d.player_id] = d.id;
            });
            setMyPendingOffers(map);
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };
    /* eslint-disable */
    useEffect(() => {
        refresh();
    }, []);
    /* eslint-enable */

    const isPresident = !!(user && user.team_id);
    const isAdmin = user?.role === "admin";

    const onClearVetrina = async () => {
        if (!window.confirm(
            "Svuotare TUTTA la vetrina?\n\nTutti gli annunci attivi verranno rimossi dalla vetrina (restano nello storico) " +
            "e per ciascun giocatore partirà il cooldown di 15 giorni prima di poterlo rimettere.\n\n" +
            "Usa questo a sessione di mercato chiusa. Procedere?"
        )) return;
        try {
            const { data } = await api.post("/market/listings/clear");
            alert(`✓ Vetrina svuotata: ${data.cleared} annunci rimossi.`);
            refresh();
        } catch (e) {
            alert(e.response?.data?.detail || "Errore");
        }
    };

    // Deep-link da scheda giocatore: ?highlight={entry_id} → scroll + evidenzia l'annuncio.
    const highlightEntry = searchParams.get("highlight") || "";
    const [flashId, setFlashId] = useState("");
    useEffect(() => {
        if (!highlightEntry || loading || listings.length === 0) return;
        const hit = listings.find((l) => l.entry_id === highlightEntry);
        if (!hit) return;
        const t = setTimeout(() => {
            const el = document.querySelector(`[data-testid="listing-${hit.id}"]`);
            if (el) {
                el.scrollIntoView({ behavior: "smooth", block: "center" });
                setFlashId(hit.id);
                setTimeout(() => setFlashId(""), 2600);
            }
        }, 300);
        return () => clearTimeout(t);
    }, [highlightEntry, loading, listings]);

    const roles = Array.from(new Set(listings.map((l) => l.position).filter(Boolean)))
        .sort((a, b) => POSITION_ORDER.indexOf(a) - POSITION_ORDER.indexOf(b));
    const teamsInVetrina = Array.from(
        new Map(listings.filter((l) => l.team_id).map((l) => [l.team_id, l.team_name])).entries()
    ).sort((a, b) => (a[1] || "").localeCompare(b[1] || ""));
    const filtered = listings.filter((l) => {
        if (typeFilter !== "all" && (l.listing_type || "sale") !== typeFilter) return false;
        if (roleFilter && l.position !== roleFilter) return false;
        if (teamFilter && l.team_id !== teamFilter) return false;
        return true;
    });
    if (priceSort) {
        filtered.sort((a, b) => {
            const pa = a.price ?? 0;
            const pb = b.price ?? 0;
            return priceSort === "desc" ? pb - pa : pa - pb;
        });
    }

    const onRemove = async (id) => {
        if (!window.confirm("Rimuovere questo giocatore dalla vetrina?")) return;
        try {
            await api.delete(`/market/listings/${id}`);
            refresh();
        } catch (e) {
            alert(e.response?.data?.detail || "Errore");
        }
    };

    const onCancelOffer = async (dealId) => {
        if (!window.confirm("Annullare l'offerta inviata per questo giocatore?")) return;
        try {
            await api.delete(`/market/deals/${dealId}`);
            refresh();
        } catch (e) {
            alert(e.response?.data?.detail || "Errore");
        }
    };

    // Apre il modale offerta DIRETTAMENTE nel mercato (senza navigare alla pagina squadra).
    const openOffer = async (l) => {
        setOfferLoadingId(l.id);
        try {
            const { data } = await api.get(`/teams/${l.team_id}/roster`);
            const entry = (data?.roster || []).find((p) => p.entry_id === l.entry_id);
            if (!entry) {
                alert("Giocatore non più disponibile in rosa.");
                return;
            }
            setOfferCtx({
                target: { ...entry, listing_price: l.price },
                sellerTeamId: l.team_id,
                sellerTeamName: l.team_name,
            });
        } catch (e) {
            alert(e.response?.data?.detail || "Errore nel caricamento del giocatore");
        } finally {
            setOfferLoadingId(null);
        }
    };

    return (
        <div data-testid="vetrina-panel">
            <section className="mt-8">
                <div className="flex items-center justify-between gap-3 flex-wrap mb-4">
                    <div className="op-label" style={{ color: "rgb(var(--tc-7ce38b))" }}>
                        // VETRINA ({filtered.length}{filtered.length !== listings.length ? ` / ${listings.length}` : ""})
                    </div>
                    <div className="flex items-center gap-2">
                    {isPresident && (
                        <button
                            className="op-btn op-btn-primary text-xs"
                            onClick={() => setShowSell(true)}
                            data-testid="open-sell-modal"
                        >
                            + Metti in vendita
                        </button>
                    )}
                    {isAdmin && (
                        <button
                            className="op-mono text-[11px] uppercase tracking-wider px-3 py-1.5 border border-tff3b30/50 text-tff3b30 hover:bg-tff3b30/10 transition-colors"
                            onClick={onClearVetrina}
                            data-testid="clear-vetrina-btn"
                        >
                            🧹 Pulisci vetrina
                        </button>
                    )}
                    </div>
                </div>

                {/* Filtri */}
                <div className="flex items-center gap-3 flex-wrap mb-5" data-testid="vetrina-filters">
                    <div className="flex">
                        {[
                            { k: "all", l: "Tutti", c: "rgb(var(--tc-c9ccd3))" },
                            { k: "sale", l: "🏷️ Vendite", c: "rgb(var(--tc-7ce38b))" },
                            { k: "loan", l: "🔁 Prestiti", c: "rgb(var(--tc-ff7a1a))" },
                        ].map((t, i) => (
                            <button
                                key={t.k}
                                onClick={() => setTypeFilter(t.k)}
                                className={`op-mono text-[11px] uppercase px-3 py-1.5 border transition-colors ${i > 0 ? "-ml-px" : ""}`}
                                style={typeFilter === t.k
                                    ? { color: t.c, borderColor: withAlpha(t.c, "88"), background: withAlpha(t.c, "1A") }
                                    : { color: "rgb(var(--tc-8f95a3))", borderColor: "rgb(var(--tc-22252a))" }}
                                data-testid={`filter-type-${t.k}`}
                            >
                                {t.l}
                            </button>
                        ))}
                    </div>
                    <select
                        value={roleFilter}
                        onChange={(e) => setRoleFilter(e.target.value)}
                        className="bg-t0e1014 border border-t22252a text-tffffff op-mono text-[11px] px-2 py-1.5"
                        data-testid="filter-role"
                    >
                        <option value="">Tutti i ruoli</option>
                        {roles.map((r) => <option key={r} value={r}>{trPositionShort(r)}</option>)}
                    </select>
                    <select
                        value={teamFilter}
                        onChange={(e) => setTeamFilter(e.target.value)}
                        className="bg-t0e1014 border border-t22252a text-tffffff op-mono text-[11px] px-2 py-1.5 max-w-[180px]"
                        data-testid="filter-team"
                    >
                        <option value="">Tutte le squadre</option>
                        {teamsInVetrina.map(([id, name]) => <option key={id} value={id}>{name}</option>)}
                    </select>
                    <select
                        value={priceSort}
                        onChange={(e) => setPriceSort(e.target.value)}
                        className="bg-t0e1014 border border-t22252a text-tffffff op-mono text-[11px] px-2 py-1.5"
                        data-testid="filter-price-sort"
                    >
                        <option value="">Prezzo: nessun ordine</option>
                        <option value="desc">Prezzo: dal più alto</option>
                        <option value="asc">Prezzo: dal più basso</option>
                    </select>
                    {(typeFilter !== "all" || roleFilter || teamFilter || priceSort) && (
                        <button
                            onClick={() => { setTypeFilter("all"); setRoleFilter(""); setTeamFilter(""); setPriceSort(""); }}
                            className="op-mono text-[11px] text-t2bb6ff hover:underline"
                            data-testid="filter-reset"
                        >
                            Azzera filtri
                        </button>
                    )}
                </div>

                {loading ? (
                    <div className="op-label text-t8f95a3 animate-pulse">// CARICAMENTO…</div>
                ) : listings.length === 0 ? (
                    <div className="op-card p-5 text-t8f95a3 text-sm" data-testid="vetrina-empty">
                        Nessun giocatore in vetrina al momento.
                        {isPresident && " Metti in vendita un tuo giocatore con il pulsante in alto."}
                    </div>
                ) : filtered.length === 0 ? (
                    <div className="op-card p-5 text-t8f95a3 text-sm" data-testid="vetrina-no-match">
                        Nessun annuncio corrisponde ai filtri selezionati.
                    </div>
                ) : (
                    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3" data-testid="vetrina-list">
                        {filtered.map((l) => {
                            const isOwn = isPresident && user.team_id === l.team_id;
                            const canOffer = isPresident && user.team_id !== l.team_id;
                            const loan = l.listing_type === "loan";
                            const accent = loan ? "rgb(var(--tc-ff7a1a))" : "rgb(var(--tc-7ce38b))";
                            return (
                                <div
                                    key={l.id}
                                    className={`op-card p-4 flex flex-col transition-all duration-500 ${flashId === l.id ? "ring-2 ring-te8ff00 shadow-[0_0_24px_rgba(232,255,0,0.35)]" : ""}`}
                                    style={{ borderTop: `3px solid ${accent}` }}
                                    data-testid={`listing-${l.id}`}
                                >
                                    <div className="flex items-start gap-3">
                                        <Link to={`/giocatori/${l.pes_id ?? l.entry_id}`} data-testid={`listing-avatar-link-${l.id}`}>
                                            <PlayerAvatar
                                                tmImage={l.tm_image}
                                                pesImage={l.pes_image_url}
                                                name={l.player_name}
                                                size={56}
                                                testId={`listing-avatar-${l.id}`}
                                            />
                                        </Link>
                                        <div className="min-w-0 flex-1">
                                            <div className="flex items-center gap-2">
                                                <FavoriteStar pesId={l.pes_id} size={16} />
                                                <Link
                                                    to={`/giocatori/${l.pes_id ?? l.entry_id}`}
                                                    className="op-heading text-lg truncate hover:text-t7ce38b transition-colors"
                                                    data-testid={`listing-name-${l.id}`}
                                                >
                                                    {l.player_name}
                                                </Link>
                                                <span
                                                    className="op-mono text-[9px] uppercase px-1.5 py-0.5 border whitespace-nowrap shrink-0"
                                                    style={{ color: accent, borderColor: withAlpha(accent, "66") }}
                                                    data-testid={`badge-vendita-${l.id}`}
                                                >
                                                    {loan ? "🔁 In prestito" : "🏷️ In vendita"}
                                                </span>
                                            </div>
                                            <div className="op-mono text-xs text-t8f95a3 mt-0.5">
                                                VG {l.vg ?? "—"} · {trPositionShort(l.position) || "—"}{l.age ? ` · ${l.age} anni` : ""}
                                            </div>
                                            {(() => {
                                                const styleLabel = rosterStyleLabel(l);
                                                return styleLabel ? (
                                                    <div className="op-mono text-[10px] text-t2bb6ff mt-0.5 truncate" title={styleLabel}>
                                                        {styleLabel}
                                                    </div>
                                                ) : null;
                                            })()}
                                            <Link
                                                to={`/squadre/${l.team_id}`}
                                                className="op-mono text-[11px] text-t8f95a3 hover:text-tffffff hover:underline mt-1 inline-block"
                                            >
                                                {l.team_name}
                                            </Link>
                                        </div>
                                    </div>

                                    <div className="mt-3 flex items-baseline gap-2">
                                        <span className="op-label text-[10px] text-t8f95a3">
                                            {loan ? "COSTO PRESTITO" : "PREZZO RICHIESTO"}
                                        </span>
                                        <span className="op-heading text-xl" style={{ color: accent }}>
                                            {loan && l.price === 0 ? "Gratuito" : `€${fmt(l.price)}`}
                                        </span>
                                    </div>
                                    {l.market_value ? (
                                        <div className="op-mono text-[10px] text-t5c6370">
                                            Valore TM: €{fmt(l.market_value)}
                                            {l.tm_value_date ? <span className="ml-1 text-t454b55">· agg. {l.tm_value_date}</span> : null}
                                        </div>
                                    ) : null}

                                    {l.note && (
                                        <div className="mt-2 text-sm text-tc9ccd3 border-l-2 border-t22252a pl-2 whitespace-pre-wrap">
                                            {l.note}
                                        </div>
                                    )}

                                    <div className="mt-auto pt-4 flex gap-2">
                                        {canOffer && (
                                            myPendingOffers[l.entry_id] ? (
                                                <div className="flex-1 flex flex-col gap-1" data-testid={`offer-pending-${l.id}`}>
                                                    <span className="op-mono text-[10px] text-t7ce38b text-center" data-testid={`offer-sent-${l.id}`}>
                                                        ✓ Offerta inviata
                                                    </span>
                                                    <button
                                                        className="op-btn text-xs border-tff4d4d text-tff4d4d hover:bg-tff4d4d/10"
                                                        onClick={() => onCancelOffer(myPendingOffers[l.entry_id])}
                                                        data-testid={`cancel-offer-listing-${l.id}`}
                                                    >
                                                        Annulla offerta
                                                    </button>
                                                </div>
                                            ) : (
                                                <button
                                                    className="op-btn op-btn-primary text-xs flex-1"
                                                    onClick={() => openOffer(l)}
                                                    disabled={offerLoadingId === l.id}
                                                    data-testid={`offer-listing-${l.id}`}
                                                >
                                                    {offerLoadingId === l.id ? "…" : "Fai offerta"}
                                                </button>
                                            )
                                        )}
                                        {isOwn && (
                                            <button
                                                className="op-btn text-xs flex-1"
                                                onClick={() => onRemove(l.id)}
                                                data-testid={`remove-listing-${l.id}`}
                                            >
                                                Rimuovi
                                            </button>
                                        )}
                                        {!isPresident && (
                                            <Link
                                                to={`/squadre/${l.team_id}`}
                                                className="op-btn text-xs flex-1 text-center"
                                            >
                                                Vedi squadra
                                            </Link>
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}
            </section>

            {showSell && (
                <SellModal
                    teamId={user.team_id}
                    onClose={() => setShowSell(false)}
                    onDone={() => { setShowSell(false); refresh(); }}
                />
            )}

            {offerCtx && (
                <MakeOfferModal
                    target={offerCtx.target}
                    sellerTeam={{ name: offerCtx.sellerTeamName }}
                    sellerTeamId={offerCtx.sellerTeamId}
                    buyerTeamId={user.team_id}
                    onClose={() => setOfferCtx(null)}
                    onDone={() => {
                        setOfferCtx(null);
                        refresh();
                        window.alert("Offerta inviata! La trovi nella sezione Trasferimenti → Inviate.");
                    }}
                />
            )}
        </div>
    );
}

export function SellModal({ teamId, onClose, onDone }) {
    const [roster, setRoster] = useState([]);
    const [entryId, setEntryId] = useState("");
    const [listingType, setListingType] = useState("sale");
    const [free, setFree] = useState(false);
    const [price, setPrice] = useState("");
    const [note, setNote] = useState("");
    const [busy, setBusy] = useState(false);
    const [err, setErr] = useState(null);

    useEffect(() => {
        api.get(`/teams/${teamId}/roster`)
            .then((r) => setRoster((r.data?.roster || []).filter((p) => !p.is_loaned_out)))
            .catch(() => setRoster([]));
    }, [teamId]);

    const isLoan = listingType === "loan";

    const submit = async () => {
        if (!entryId) { setErr("Seleziona un giocatore."); return; }
        const isLoanFree = isLoan && free;
        const p = isLoanFree ? 0 : parseFloat(price);
        if (!isLoanFree && (isNaN(p) || p < 0)) { setErr("Inserisci un valore valido (in milioni)."); return; }
        const ok = window.confirm(
            "Pubblicando questo giocatore in vetrina:\n" +
            "• resterà in vetrina per 15 giorni, poi esce da solo (puoi anche toglierlo prima)\n" +
            "• NON potrai modificare l'annuncio, solo toglierlo\n" +
            "• una volta uscito (tolto o scaduto) non potrai rimetterlo in vetrina per 15 giorni\n\n" +
            "Confermare la pubblicazione?"
        );
        if (!ok) return;
        setBusy(true); setErr(null);
        try {
            await api.post("/market/listings", { entry_id: entryId, listing_type: listingType, price_mln: p, note });
            onDone();
        } catch (e) {
            setErr(e.response?.data?.detail || "Errore");
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur p-4" data-testid="sell-modal">
            <div className="op-card max-w-md w-full p-5">
                <div className="op-label mb-2" style={{ color: "rgb(var(--tc-7ce38b))" }}>// METTI IN VETRINA</div>

                <label className="op-label text-[10px] text-t8f95a3">TIPO</label>
                <div className="flex gap-2 mt-1 mb-3">
                    <button
                        type="button"
                        onClick={() => setListingType("sale")}
                        className={`flex-1 op-mono text-xs uppercase py-2 border transition-colors ${isLoan ? "border-t22252a text-t8f95a3" : "border-t7ce38b text-t7ce38b bg-t7ce38b/10"}`}
                        data-testid="sell-type-sale"
                    >
                        🏷️ Vendita
                    </button>
                    <button
                        type="button"
                        onClick={() => setListingType("loan")}
                        className={`flex-1 op-mono text-xs uppercase py-2 border transition-colors ${isLoan ? "border-tff7a1a text-tff7a1a bg-tff7a1a/10" : "border-t22252a text-t8f95a3"}`}
                        data-testid="sell-type-loan"
                    >
                        🔁 Prestito
                    </button>
                </div>

                <label className="op-label text-[10px] text-t8f95a3">GIOCATORE</label>
                <select
                    className="op-input w-full mt-1 mb-3"
                    value={entryId}
                    onChange={(e) => setEntryId(e.target.value)}
                    data-testid="sell-player-select"
                >
                    <option value="">Seleziona…</option>
                    {roster.map((p) => (
                        <option key={p.entry_id} value={p.entry_id}>
                            {p.name} (VG {p.vg ?? "—"} · {trPositionShort(p.position) || "—"}){p.is_ugly ? " · Ugly" : ""}
                        </option>
                    ))}
                </select>

                {isLoan && (
                    <label className="flex items-center gap-2 mb-2 cursor-pointer">
                        <input type="checkbox" checked={free} onChange={(e) => setFree(e.target.checked)}
                            className="accent-tff7a1a w-4 h-4" data-testid="sell-free-loan" />
                        <span className="text-sm text-tc9ccd3">Prestito gratuito</span>
                    </label>
                )}

                <label className="op-label text-[10px] text-t8f95a3">
                    {isLoan ? "COSTO PRESTITO (in milioni)" : "PREZZO RICHIESTO (in milioni)"}
                </label>
                <input
                    type="number"
                    step="0.1"
                    min="0"
                    disabled={isLoan && free}
                    className="op-input w-full mt-1 mb-3 disabled:opacity-40"
                    value={isLoan && free ? "" : price}
                    onChange={(e) => setPrice(e.target.value)}
                    placeholder={isLoan && free ? "Gratuito" : "es. 15.5"}
                    data-testid="sell-price-input"
                />

                <label className="op-label text-[10px] text-t8f95a3">NOTA (opzionale)</label>
                <textarea
                    className="op-input w-full mt-1"
                    rows={3}
                    value={note}
                    onChange={(e) => setNote(e.target.value)}
                    placeholder="es. Valuto scambi con un CB, prezzo trattabile…"
                    data-testid="sell-note-input"
                />

                {err && <div className="op-card p-3 mt-3 text-sm text-tff4d4d border-tff4d4d/40">{err}</div>}

                <div className="flex justify-end gap-2 mt-5">
                    <button className="op-btn" onClick={onClose} disabled={busy} data-testid="sell-cancel">Annulla</button>
                    <button className="op-btn op-btn-primary" onClick={submit} disabled={busy} data-testid="sell-confirm">
                        {busy ? "Pubblicazione…" : "Pubblica in vetrina"}
                    </button>
                </div>
            </div>
        </div>
    );
}

